import axios from 'axios';

const axiosInstance = axios.create();

const getStoredToken = () => {
    const token = localStorage.getItem('global-article-master-token');

    if (!token || token === 'null' || token === 'undefined') {
        return undefined;
    }

    return token;
}

axiosInstance.interceptors.request.use(
    request => {
        const token = getStoredToken();

        if (token) {
            request.headers['Authorization'] = `Bearer ${token}`;
        }

        request.headers['Content-Type'] = 'application/json';
        return request
    },
    error => {
        console.log(error);
    }
)

axiosInstance.interceptors.response.use(function (response) {
    if (response.headers['x-refresh-token']) {
        localStorage.setItem('global-article-master-token', response.headers['x-refresh-token']);
    }
    return response;
}, function (error) {
    return Promise.reject(error);
});

export default axiosInstance;